<template>
  <div class="ownClassManagement">
    <div class="user-info-list-body">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="createCurriculumSystem"
          icon="el-icon-plus"
          >添加体系</el-button
        >
      </div>
      <el-form
        ref="ruleForm"
        :inline="true"
        :model="ruleForm"
        class="form-style"
        size="mini"
      >
        <el-form-item label="科目" prop="subject_id">
          <el-select v-model="ruleForm.subject_id" filterable>
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of subjectList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授课类型" prop="teaching_type">
          <el-select v-model="ruleForm.teaching_type" style="width: 150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="面授课" value="1"></el-option>
            <el-option label="直播课" value="2"></el-option>
            <el-option label="录播课" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程类型" prop="curriculum_type">
          <el-select v-model="ruleForm.curriculum_type" style="width: 150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="体验课" value="1"></el-option>
            <el-option label="常规课" value="2"></el-option>
            <el-option label="短期课" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布类型">
          <el-select v-model="ruleForm.is_try" style="width: 150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="体验校区" value="1"></el-option>
            <el-option label="合作校区" value="0"></el-option>
          </el-select>
          <!-- <el-radio-group v-model="ruleForm.is_try">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group> -->
        </el-form-item>
        <el-form-item label="是否有效">
          <el-select v-model="ruleForm.is_effective" style="width: 150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
          <!-- <el-radio-group v-model="ruleForm.is_effective">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group> -->
        </el-form-item>

        <el-form-item>
          <el-button @click="search" type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="table-style">
        <el-table
          size="mini"
          :data="tableData"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column label="序号" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (page_no - 1) * 20 }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" prop="id" label="封面">
            <template slot-scope="scope">
              <el-image
                style="width: 48px; height: 36px"
                :src="scope.row.img_url"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            prop="title"
            label="课程名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column prop="subjectName" label="科目"></el-table-column>
          <el-table-column prop="teaching_type" label="类别">
            <template slot-scope="scope">
              {{
                scope.row.teaching_type === 1
                  ? '面授课'
                  : scope.row.teaching_type === 2
                  ? '直播课'
                  : '录播课'
              }}
            </template>
          </el-table-column>

          <el-table-column prop="curriculum_type" label="类型">
            <template slot-scope="scope">
              {{
                scope.row.curriculum_type === 1
                  ? '体验课'
                  : scope.row.curriculum_type === 2
                  ? '常规课'
                  : '短期课'
              }}
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            prop="for_grade"
            label="适合年龄"
            :show-overflow-tooltip="true"
          ></el-table-column>

          <el-table-column
            width="100"
            prop="suggested_duration"
            label="推荐时长"
            :show-overflow-tooltip="true"
          ></el-table-column>

          <el-table-column
            width="150"
            label="课程难度"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-rate v-model="scope.row.difficulty" :colors="colors" disabled>
              </el-rate>
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            prop="curriculum_desc"
            label="简介"
            :show-overflow-tooltip="true"
          ></el-table-column>

          <el-table-column
            prop="number_of_courses"
            label="节数"
            align="center"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="state"
            label="状态"
          ></el-table-column>

          <el-table-column
            prop="sort_num"
            label="排序"
            width="60"
          ></el-table-column>

          <el-table-column
            align="center"
            label="操作"
            width="150px"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="editCurriculum(scope.row)"
                >查看/修改</el-button
              >

              <!-- 有效/无效 -->
              <el-button
                size="mini"
                type="text"
                v-if="scope.row.is_effective"
                @click="updateCurriculumEffective(scope.row, 0)"
                >有效</el-button
              >
              <el-button
                size="mini"
                type="text"
                v-if="!scope.row.is_effective"
                @click="updateCurriculumEffective(scope.row, 1)"
                >无效</el-button
              >

              <el-button
                size="mini"
                type="text"
                @click="deleteCurriculum(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page_no"
          layout="total, prev, pager, next"
          :total="total"
          :page-size="20"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdminSubjectListWithOutPageInfo } from '@/api/admin'
import {
  getCurriculumList,
  deleteCurriculum,
  updateCurriculumEffective,
} from '@/api/educational'

export default {
  name: 'platform-curriculum',
  data() {
    return {
      state: 1,
      ruleForm: {
        search_type: '1',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        class_start_time: '',
        class_end_time: '',
        is_goods: '',
        course_type: '1',
        course_state: '',
        curriculum_type: '',
        is_try: '', //是否用于体验校区的课程体系
        is_effective: '', //是否有效
      },
      classStartTime: '',
      subjectList: [],
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 20,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
    }
  },
  mounted() {
    this.getUserSubjectList()
    this.getCurriculumList()
  },
  methods: {
    createCurriculumSystem() {
      this.$router.push({ name: 'create-admin-course-system' })
    },
    // 获取科目
    getUserSubjectList() {
      getAdminSubjectListWithOutPageInfo({
        subject_state: 1,
      }).then((res) => {
        this.subjectList = res.subject_list
      })
    },
    // 获取课程体系
    getCurriculumList() {
      getCurriculumList(
        {
          is_try: this.ruleForm.is_try,
          is_effective: this.ruleForm.is_effective,
          subject_id: this.ruleForm.subject_id,
          teaching_type: this.ruleForm.teaching_type,
          curriculum_type: this.ruleForm.curriculum_type,
          page_no: this.page_no,
          page_size: this.page_size,
        },
        true
      ).then((res) => {
        this.tableData = res.curriculum_list
        this.total = res.total
        console.log(this.tableData)
      })
    },
    search() {
      this.page_no = 1
      this.getCurriculumList()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getCurriculumList()
    },
    // 删除课程体系
    deleteCurriculum(row) {
      this.$confirm('此操作将永久删除该课程体系, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCurriculum(
          {
            curriculum_id: row.id,
          },
          true
        ).then(() => {
          this.$message.success('删除成功')
          this.getCurriculumList()
        })
      })
    },
    updateCurriculumEffective(row, effective) {
      this.$confirm(
        `确定设置该课程体系为${effective === 0 ? '无效' : '有效'}？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        updateCurriculumEffective(
          {
            curriculum_id: row.id,
            is_effective: effective,
          },
          true
        ).then(() => {
          this.$message.success('设置成功')
          this.getCurriculumList()
        })
      })
    },
    editCurriculum(row) {
      this.$router.push({
        name: 'edit-admin-course-system',
        query: {
          id: row.id,
          type: row.state,
          subjectName: row.subjectName,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ownClassManagement {
  .user-info-list-body {
    margin: 10px;
    padding: 15px;
    background-color: #ffffff;
    border-radius: 5px;

    .label-title {
      font-size: 14px;
    }

    .search-list {
      margin-top: 20px;
      display: inline-block;
      margin-left: 20px;
    }
  }
}
</style>
